import React, { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

function DetalleCarga({ id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Función para obtener los datos desde la API
  const fetchData = async (id) => {
    const apiCreateServicesGhostAPI = API_ENDPOINTS.interna.CreateServicesGhostAPI(id);

    try {
      const response = await fetch(apiCreateServicesGhostAPI);
      if (!response.ok) {
        throw new Error(`Error en la API: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      return null;
    }
  };

  // Efecto para cargar los datos al montar el componente
  useEffect(() => {
    const loadData = async () => {
      const apiData = await fetchData(id);
      if (apiData && apiData.ExcelCarga) {
        const parsedData = JSON.parse(apiData.ExcelCarga).data;
        setData(parsedData);
      }
      setLoading(false);
    };
    loadData();
  }, [id]);

  // Función para agrupar los datos por un campo específico
  const groupBy = (array, key) =>
    array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  }

  const groupedData = groupBy(data, "Grupo");

  return (
    <div className="container-fluid my-5">
      {Object.entries(groupedData).map(([group, entries]) => (
        <div key={group} className="mb-4">
          {/* Encabezado del Grupo */}
          <div className="row bg-primary text-white p-2 rounded shadow">
            <div className="col-12">
              <h3>Grupo {group}</h3>
            </div>
          </div>

          {/* Detalle de los Pasajeros */}
          {entries.map((entry, index) => (
            <div key={index} className="row border rounded shadow-sm p-3 my-3 align-items-start bg-white shadow-lg">
              {/* Información principal */}
              <div className="col-md-2">
                <strong>Nombre:</strong>
                <div>{entry.Nombre}</div>
              </div>
              <div className="col-md-2">
                <strong>RUT:</strong>
                <div>{entry.Rut}</div>
              </div>
              <div className="col-md-2">
                <strong>Teléfono:</strong>
                <div>{entry.Telefono}</div>
              </div>
              <div className="col-md-2">
                <strong>Origen:</strong>
                <div>{entry.Origen}</div>
              </div>
              <div className="col-md-2">
                <strong>Destino:</strong>
                <div>{entry.Destino}</div>
              </div>
              <div className="col-md-2">
                <strong>Fecha y Hora:</strong>
                <div>{entry.FechaProgramado}</div>
                <div>{entry.HoraProgramado}</div>
              </div>

              {/* Coordenadas debajo del nombre */}
              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <strong>Coordenadas Origen:</strong>
                    <div>
                      {entry.origin.latitude}, {entry.origin.longitude}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <strong>Coordenadas Destino:</strong>
                    <div>
                      {entry.destination.latitude}, {entry.destination.longitude}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default DetalleCarga;
